<template>
  <div class="page">
    <el-card>
      <div slot="header" class="clearfix">
        <span>财务管理 - 提现审核</span>
      </div>

      <!-- 表格 -->
      <el-table
        :data="records"
        border
        stripe
        style="width: 100%"
        v-loading="loading"
      >
        <el-table-column prop="id" label="提现ID" width="100" />

        <el-table-column label="用户ID" width="120">
          <template slot-scope="{ row }">
            {{ row.user_id }}
          </template>
        </el-table-column>

        <el-table-column prop="amount" label="提现金额(元)" width="140" />

        <el-table-column prop="create_time_text" label="申请时间" width="180" />

        <el-table-column label="状态" width="120">
          <template slot-scope="{ row }">
            <el-tag :type="statusTag(row.status)">
              {{ statusText(row.status) }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 操作：只有 pending 才能审核 -->
        <el-table-column label="操作" width="200" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.status === 'pending'"
              type="success"
              size="mini"
              @click="approve(row)"
            >
              打款
            </el-button>

            <el-button
              v-if="row.status === 'pending'"
              type="danger"
              size="mini"
              @click="reject(row)"
            >
              拒绝
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-box">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :page-size="pageSize"
          :page-sizes="[5, 10, 20, 50]"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import axios from "axios"

export default {
  name: "Finance",
  data() {
    return {
      records: [],
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0
    }
  },

  mounted() {
    this.loadRecords()
  },

  methods: {
    // 状态文本
    statusText(status) {
      return {
        pending: "待审核",
        approved: "已打款",
        rejected: "已拒绝"
      }[status] || status
    },

    // 状态颜色
    statusTag(status) {
      return {
        pending: "warning",
        approved: "success",
        rejected: "danger"
      }[status] || "info"
    },

    // 加载提现记录（后端分页）
    async loadRecords() {
      this.loading = true
      try {
        const res = await axios.get(
          "https://wx.hzxcet.com/api/withdraw/list",
          {
            params: {
              page: this.currentPage,
              page_size: this.pageSize
            }
          }
        )

        const { code, data, total, page, page_size } = res.data
        if (code === 0) {
          this.records = data
          this.total = total
          this.currentPage = page
          this.pageSize = page_size
        } else {
          this.$message.error("获取提现数据失败")
        }
      } catch (err) {
        this.$message.error("接口请求失败")
      } finally {
        this.loading = false
      }
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadRecords()
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.loadRecords()
    },

    // 审核 - 打款
    async approve(row) {
      try {
        await this.$confirm("确认已打款？", "提示", { type: "success" })
      } catch {
        return
      }

      this.loading = true
      try {
        const res = await axios.post(
          "https://wx.hzxcet.com/api/withdraw/audit",
          {
            id: row.id,
            action: "approve",
          }
        )

        if (res.data.code === 0) {
          this.$message.success("打款成功")
          this.loadRecords()
        } else {
          this.$message.error(res.data.msg || "操作失败")
        }
      } catch (err) {
        this.$message.error("打款接口异常")
      } finally {
        this.loading = false
      }
    },

    // 审核 - 拒绝
    async reject(row) {
      try {
        await this.$confirm("确认拒绝提现申请？", "提示", { type: "warning" })
      } catch {
        return
      }

      this.loading = true
      try {
        const res = await axios.post(
          "https://wx.hzxcet.com/api/withdraw/audit",
          {
            id: row.id,
            action: "reject",
            remark: "审核拒绝：不符合提现条件"
          }
        )

        if (res.data.code === 0) {
          this.$message.warning("已拒绝提现")
          this.loadRecords()
        } else {
          this.$message.error(res.data.msg || "操作失败")
        }
      } catch (err) {
        this.$message.error("拒绝接口异常")
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.page {
  padding: 10px;
}
.pagination-box {
  margin-top: 20px;
  text-align: right;
}
</style>
